<template>
  <div>
    <div class="topbox">
      <!-- <div class="flexcenter">

      </div> -->
      <img class="thumimg" :src="userinfo.avatar" />
      <div>
        <div class="textfont marginbottom" style="color: #FFFFFF;">{{ userinfo.username ? userinfo.username :
          userinfo.nickname }}</div>
        <!-- <div class="tiptext tipcolor" @click="changePhone">手机号：{{userinfo.mobile ? userinfo.mobile : '暂未绑定'}}</div> -->
      </div>
      <div class="delSession" @click="delSession">清除缓存</div>
    </div>
    <div class="mine-menubox">
      <div class="paddingtb1 flexbetween  borderbottom" @click="toStore">
        <div class="flexcenter">
          <img class="menuimg" src="/static/mine/store.png" />
          <div class="tiptext">我的门店</div>
        </div>
        <img class="gengduoicon" src="/static/more.png" />
      </div>
      <div class="paddingtb1 flexbetween borderbottom" @click="toOrder">
        <div class="flexcenter">
          <img class="menuimg" src="/static/mine/order.png" />
          <div class="tiptext">核销订单</div>
        </div>
        <img class="gengduoicon" src="/static/more.png" />
      </div>
      <div class="paddingtb1 flexbetween borderbottom" @click="toSettlement">
        <div class="flexcenter">
          <img class="menuimg" src="/static/mine/settlement.png" />
          <div class="tiptext">结算订单</div>
        </div>
        <img class="gengduoicon" src="/static/more.png" />
      </div>
      <div class="paddingtb1 flexbetween borderbottom" @click="toStaffList">
        <div class="flexcenter">
          <img class="menuimg" src="/static/mine/guanli.png" />
          <div class="tiptext">店员管理</div>
        </div>
        <img class="gengduoicon" src="/static/more.png" />
      </div>
      <div class="paddingtb1 flexbetween borderbottom" @click="toAdminNum">
        <div class="flexcenter">
          <img class="menuimg" src="/static/mine/change.png" />
          <div class="tiptext">修改账号</div>
        </div>
        <img class="gengduoicon" src="/static/more.png" />
      </div>
      <a href="tel:4008932218">
        <div class="paddingtb1 flexbetween">
          <div class="flexcenter">
            <img class="menuimg" src="/static/mine/phone.png" />
            <div class="tiptext">联系客服</div>
          </div>
          <img class="gengduoicon" src="/static/more.png" />
        </div>
      </a>
    </div>
    <div v-if="showChange" class="bill-detail-startbox"
      :class="showChange ? 'bill-detail-startshow' : 'bill-detail-startclose'">
      <div class="changePhone">
        <div class="flex-centerCloumn">
          <div class="textfont marginbottom1">绑定手机号</div>
          <div class="recharge-maintop" style="padding: 0;">
            <div class="recharge-maintext">手机号码</div>
            <input class="recharge-main-input" v-model="phoneNum" placeholder="请输入手机号码号码" />
          </div>
          <div class="yanzheng_inputfrom">
            <div class="recharge-maintext">验证码</div>
            <div class="yanzheng_input">
              <input class="yanzheng_inputyz" type="number" placeholder="请输入验证码" v-model="phoneCode"
                @input="input('phoneCode')" />
              <div class="yanzheng_get" @click='!currentTime ? tap("getPhoneCode") : ""'> {{ currentTime ? currentTime :
                "获取验证码" }}</div>
            </div>
          </div>
          <div class="flexbetween" style="margin-top: 10px;">
            <div class="changebotton-cancel" @click="calcel">取消</div>
            <div class="changebotton-confirm" @click='!buttonClicked ? tap("changePhoneNum") : ""'>确认绑定</div>
          </div>
        </div>
      </div>
    </div>
    <taber></taber>
  </div>
</template>

<script>
import taber from '@/components/taber/taber'
import httper from '../../../api/http';
var phone_mreg = /^1[2-9][0-9]{9}$/;
import {
  Dialog
} from 'vant';
export default {
  components: {
    taber
  },
  data() {
    return {
      phoneNum: '', // 全局变量获取原有手机号码,默认为空
      phoneCode: '', // 验证码,默认为空
      currentCode: '', // 接口获取正确的验证码,默认为空
      currentTime: '', // 验证码倒计时,默认为空
      buttonClicked: false, // 防止支付重复点击,默认为false
      showChange: false, //是否绑定手机号
      userinfo: {},
    }
  },
  created() {
    console.log("userinfo", JSON.parse(localStorage.getItem('userinfo')))
    if (localStorage.getItem('userinfo')) {
      this.userinfo = JSON.parse(localStorage.getItem('userinfo'));
    } else {
      this.request("userInfo")
    }
  },
  mounted() {

  },
  methods: {
    /**
     * 防重点击
     * @param duration
     * @returns {Promise<any>}
     */
    buttonClickedFun(duration = 0) {
      this.buttonClicked = true
      return new Promise((resolve, reject) => {
        if (duration && typeof duration === 'number') {
          setTimeout(() => {
            this.buttonClicked = false
          }, duration)
        }
        resolve(true)
      })
    },
    //我的门店
    toStore() {
      this.$router.push({
        path: "/storeMesg"
      })
    },
    //核销订单
    toOrder() {
      this.$router.push({
        path: "/verifyOrder"
      })
    },
    //结算订单
    toSettlement() {
      this.$router.push({
        path: `/settlement/index`
      })
    },
    //店员管理
    toStaffList() {
      this.$router.push({
        path: "/staffList"
      })
    },
    //修改账号
    toAdminNum() {
      this.$router.push({
        path: "/adminNum"
      })
    },
    //显示绑定手机号
    changePhone() {
      this.showChange = true
    },
    calcel() {
      this.showChange = false
    },
    //清除缓存
    delSession() {
      Dialog.confirm({
        title: '提示',
        message: '确定清除缓存？',
      })
        .then(() => {
          localStorage.removeItem('access_token');
          localStorage.removeItem('userinfo');
          localStorage.removeItem('mobile');
          this.$router.push({
            path: "/"
          })
          // wx.closeWindow()
        })
        .catch(() => {
          return false;
        });
    },
    // 点击触发
    tap(type, params = '') {
      let that = this
      let requestData = {}
      switch (type) {
        // 获取验证码
        case 'getPhoneCode':
          that.buttonClickedFun(1500)
          if (!phone_mreg.test(that.phoneNum)) {
            that.$toast({
              message: '请输入正确手机号',
            });
            return
          }
          requestData.mobile = that.phoneNum
          that.request('sendCode', requestData)
          break
        // 绑定手机号码
        case 'changePhoneNum':
          that.buttonClickedFun(1500)

          if (!phone_mreg.test(that.phoneNum)) {
            that.buttonClicked = false
            that.$toast({
              message: '请输入正确手机号！',
            })
            return
          }

          if (that.phoneCode == '') {
            that.$toast({
              message: '验证码不能为空！',
            })
            return
          }
          if (that.phoneCode != that.currentCode) {
            that.buttonClicked = false
            that.$toast({
              message: '请输入正确的验证码！',
            })
            return
          }
          requestData.mobile = that.phoneNum
          that.request('bindMobile', requestData)
          that.buttonClicked = false
          break
      }
    },
    // 调用接口
    request(type = '', requestData = {}) {
      let that = this
      switch (type) {
        // 发送短息验证码
        case 'sendCode':
          httper.post('msg/send-code', requestData, res => {
            console.log('code：', res.data)
            if (res.code == 0) {
              that.currentCode = res.data
              that.$toast({
                message: '验证码已发送',
              });
              // 倒计时
              let time = 91
              let interval = setInterval(() => {
                time--
                if (time > 10) {
                  that.currentTime = time + '秒'
                }
                if (time > 0 && time <= 10) {
                  that.currentTime = ' ' + time + '秒'
                }
                if (time <= 0) {
                  clearInterval(interval)
                  that.currentTime = ''
                }
              }, 1000)
            }
          })
          break
        // 绑定手机
        case 'bindMobile':
          httper.post('wechat/user/bind-mobile', requestData, res => {
            console.log("res", res)
            if (res.code == 0) {
              // localStorage.setItem('mobile', res.data.mobile);
              localStorage.removeItem('userinfo');
              localStorage.setItem('userinfo', JSON.stringify(res.data));
              that.$toast({
                message: '绑定成功',
              });
              setTimeout(() => {
                that.$router.push({
                  path: "/",
                  query: {
                    lottery_code: that.lottery_code
                  }
                })
                // history.back()
              }, 1000)
            } else {
              that.$toast({
                message: res.message || '操作失败',
              });
            }
          }, true)
          break
        //获取用户信息
        case 'userInfo':
          httper.get('wechat/user/info', requestData, function (res) {
            if (res.code == 0) {
              this.userinfo = res.data
            } else {
              that.$toast({
                message: res.message || '操作失败',
              });
            }
          }, true)
          break
      }
    },
  }
}
</script>

<style>
.topbox {
  width: calc(100% - 40px);

  height: 192px;
  background-image: url(../../../static/mine/minebg.png);
  background-size: 100% 100%;
  margin: 20px 20px 0 20px;
  padding: 20px;
  box-sizing: border-box;
  /* background-color: #FFFFFF; */
  display: flex;
  align-items: center;
  position: relative;
}

.thumimg {
  width: 50px;
  height: 50px;
  margin-right: 10px;
  border-radius: 25px;
}

.mine-menubox {
  width: 100%;
  background-color: #FFFFFF;
  padding: 0 20px;
  box-sizing: border-box;
}

.menuimg {
  width: 26px;
  height: 26px;
  margin-right: 10px;
}

.gengduoicon {
  width: 15px;
  height: 15px;
}

.bill-detail-startbox {
  width: 100%;
  height: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 2;
  background-color: rgba(0, 0, 0, .5);
}

.bill-detail-startshow {
  display: block;
}

.bill-detail-startclose {
  display: none;
}

.changePhone {
  width: calc(100% - 40px);
  margin: 0 20px;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 8px;
  background-color: #FFFFFF;
  margin-top: 150px;
}

.changebotton-cancel {
  width: 115px;
  height: 46px;
  background: #EEFAF6;
  border-radius: 23px;
  margin-right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0ED49B;
}

.changebotton-confirm {
  width: 115px;
  height: 46px;
  background: #0ED49B;
  border-radius: 23px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
}

.recharge-maintop {
  width: 100%;
  border-bottom: 1px solid #E5E5E5;
  padding: 10px 18px;
  box-sizing: border-box;
}

.recharge-maintext {
  font-size: 14px;
  color: #666666;
  margin-bottom: 10px;
}

.recharge-main-input {
  width: calc(100% - 60px);
  height: 46px;
  display: flex;
  align-items: center;
}

.yanzheng_inputfrom {
  width: 100%;
  margin: 10px 0;
  /*  padding: 10px;
    box-sizing: border-box; */
}

.yanzheng_input {
  display: flex;
  height: 100%;
  align-items: center;
}

.yanzheng_inputyz {
  /*    font-size: 14px; */
  width: calc(100% - 110px);
  /* padding: 6px; */
  border: none;
  border-bottom: 1px solid #dedede;
  height: 30px;
}

.yanzheng_get {
  width: 110px;
  height: 40px;
  border: 1px solid #0ED49B;
  border-radius: 20px;
  font-size: 16px;
  font-weight: 400;
  color: #0ED49B;
  display: flex;
  justify-content: center;
  align-items: center;
}

a:link {
  color: #333333;
  /* text-decoration:underline; */
}

.delSession {
  width: 77px;
  height: 23px;
  background: #00A0E9;
  border-radius: 12px 0px 0px 12px;
  position: absolute;
  top: 40%;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/mine/mine.vue